import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components"
import useAdminLogout from "../../../modules/admin/hooks/use-admin-logout";
import { getLibraryListRoute, getAddLibraryRoute, getAdminMainRoute } from "../../../routes/routes";

type Props = {}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    padding-bottom: 1em;
    margin-bottom: 2em;
    border-bottom: 1px solid black;

    .left {
        display: flex;
        flex-direction: row;

        a {
            display: inline-block;
            margin: 0 1em;
        }
    }
`;

const AdminMenu: React.FC<Props> = () => {

    const { adminLogout } = useAdminLogout()
    return <Container>
        <div className="left">
                <Link to={getAdminMainRoute()}>Ustawienia aplikacji</Link>
                <Link to={getLibraryListRoute()}>Lista bibliotek</Link>
                <Link to={getAddLibraryRoute()}>Dodaj biblioteki do bazy</Link>
        </div>
        <div className="right">
            <button onClick={() => adminLogout()}>Wyloguj</button>
        </div>
    </Container>
}

export default AdminMenu;
